module.exports = __webpack_public_path__ + "img/defaultAvatar.3a471899.svg";